import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {AppMenuItem, AppMenuItemClickEvent} from './app-menu.model';

@Injectable({providedIn: 'root'})
export class AppMenuService {
	private readonly itemClick$ = new Subject<AppMenuItemClickEvent>();
	private readonly itemSelect$ = new Subject<AppMenuItemClickEvent>();

	constructor(private readonly router: Router) {
	}

	onSubmenuToggle(): Observable<unknown> {
		return this.itemClick$.asObservable();
	}

	onItemClick(): Observable<AppMenuItemClickEvent> {
		return this.itemClick$.asObservable();
	}

	onItemSelect(): Observable<AppMenuItemClickEvent> {
		return this.itemSelect$.asObservable();
	}

	navigateHome(): void {
		this.router.navigate(['/']);
	}

	notifyClick(event: AppMenuItemClickEvent): void {
		this.itemClick$.next(event);
		this.itemSelect$.next(event);
	}
}
